






























import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { debounce, uniqBy } from "lodash";
import { User as IUser } from "@/api/models/user";
import { UsersList as IUsersList } from "@/api/models/users-list";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { LecturesList as ILecturesList } from "@/api/models/lectures-list";
import { CategoryList as ICategoryList } from "@/api-v2/category/models/category-list";
import { CourseListenersList as ICourseListenersList } from "@/api/models/course-listeners-list";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { Lecture as ILecture } from "@/api/models/lecture";
import { Employee as IEmployee } from "@/api/models/employee";
import { Contractor as IContractor } from "@/api/models/contractor";
import { Category as ICategory } from "@/api-v2/category/models/category";
import { Course as ICourse } from "@/api/models/course";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { Video as IVideo } from "@/api/models/video";
import { VideoList as IVideoList } from "@/api/models/video-list";
import { WebinarList as IWebinarList } from "@/api/models/webinar-list";
import { EducationProtocolShort as IEducationProtocolShort } from "@/api/models/education-protocol-short";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import { EducationProtocolShortList as IEducationProtocolShortList } from "@/api/models/education-protocol-short-list";
import userList, { UsersListParams } from "@/getinfo-api/users";
import contractors, { ContractorsListParams } from "@/getinfo-api/contractors";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import lectures, { LectureListParams } from "@/getinfo-api/lectures";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import course, { CourseListParams } from "@/getinfo-api/course";
import webinars, { WebinarsListParams } from "@/getinfo-api/webinars";
import video, { VideoListParams } from "@/getinfo-api/video";
import { CourseUnionList } from "@/api/models/course-union-list";

import educationProtocol, {
  EducationProtocolListParams
} from "@/getinfo-api/education-protocol";
import courseListeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import {
  isRoot,
  getCurrentUserId,
  getCurrentCompanyId,
  getCurrentEmployee,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import api, { categoryApi } from "@/getinfo-api";

@Component
export default class SelectEntity extends Vue {
  /**
   * !!!
   * Этот компонент следует использовать только в формах создания/редактирования сущностей. Если где-то нужно отобразить
   * выпадающий список непосредственно слушателю, то следует воспользоваться нативным или b-input компонентом,
   * Сделано это в связи с тем, чтобы не смешивать выбранные сущности (как сущности слушателя и сущности работника
   * компании).
   * В данном компоненте доступен только одиночный выбор, если нужен множественный выбор, то следует обрабатывать
   * приходящие из компонента сущности в самих шаблонах.
   * !!!
   *
   * Доступные типы входных параметров для type:
   * "users (Все пользователи)", "contractors (Контрагенты)", "document_managers" (Менеджеры по документам),
   * "lectures (Лекции)", "content_managers (Контент менеджеры/методисты)",
   * "learning_request_manager (Менеджеры по заявкам)", "categories" (Категории), "courses" (Курсы),
   * "webinars" (Вебинары), "videos" (Видео), "course_listener" (слушатели курса, обязательно передается id курса),
   * "webinar_listener (слушатели курса, обязательно передается id вебинара)",
   * "video_listener (слушатели записей, обязательно передается id записи)"
   * "education_protocol" (протокол обучения)
   *
   * propEntity: Используется для получения сущности при редактировании форм.
   * Для получения:
   * 1) User - userId: string
   * 2) Contractor - contractorId: string
   * 3) Document_manager, Learning_request_manager, Content_manager - { companyId: string, responsibleId: string }
   * 4) Categories - CategoryId: string
   * 5) Courses - CourseId: string
   * 6) Webinars - WebinarId: string
   * 7) Videos - VideoId: string
   * 8) Course_Listener" - CourseId: string
   * 9) Webinar_Listener - WebinarId: string
   * 10) Video_Listener - VideoId: string
   */
  @Prop() type!: string;
  @Prop() propEntity?: any;
  @Prop() placeholder?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: true }) showFirstOption?: boolean;
  @Prop({ default: false }) isLabelHasPlusButton?: boolean;
  @Prop() searchParams?: any;

  entityList!:
    | Array<
        | IUser
        | IEmployee
        | IContractor
        | ILecture
        | ICategory
        | ICourse
        | IVideo
        | ICourseListener
        | IWebinar
        | IEducationProtocolShort
        | IEducationProtocol
      >
    | undefined;
  entity!:
    | IUser
    | IEmployee
    | IContractor
    | ILecture
    | ICategory
    | ICourseListener
    | ICourse
    | IVideo
    | IWebinar
    | IEducationProtocol
    | IEducationProtocolShort
    | undefined;
  showSpinner: boolean = false;

  data() {
    return {
      entityList: undefined,
      entity: undefined
    };
  }

  // Определение обработчика при вводе текста в строку поиска в зависимости от типа входного параметра
  searchEntity(item: string) {
    if (item.length > 2) {
      if (this.type === "users") this.getUsers(item);
      if (this.type === "contractors") this.getContractors(item);
      if (this.type === "lectures") this.getLectures(item);
      if (this.type === "document_managers") this.getDocumentManagers();
      if (this.type === "content_managers") this.getContentManagers();
      if (this.type === "learning_request_manager")
        this.getLearningRequestManager();
      if (this.type === "categories") this.getCategories();
      if (this.type === "courses") this.getCourses(item);
      if (this.type === "webinars") this.getWebinars(item);
      if (this.type === "videos") this.getVideos(item);
      if (this.type === "education_protocol") this.getEducationProtocols(item);
    } else {
      return false;
    }
  }

  checkDisabled(option: any) {
    let checked = "";
    if (option?.hasOwnProperty("enabled")) {
      checked = option?.enabled ? "" : "entity-disabled";
    }
    return checked;
  }

  getLabel(option: any) {
    let label;

    if (this.type === "contractors") {
      label = `${option.shortTitle || ""}`;
    }

    if (this.type === "users") {
      label = `${option.fullName}`;
    }

    if (this.type === "video_listener") {
      label = `${option.lastName || ""} ${option.firstName ||
        ""} ${option.middleName || ""}`;
    }

    if (this.type === "webinar_listener") {
      label = `${option.lastName || ""} ${option.firstName ||
        ""} ${option.middleName || ""}`;
    }

    if (this.type === "lectures") {
      label = `${option.title}`;
    }

    if (this.type === "course_listener") {
      label = `${option.user.lastName} ${option.user.firstName} ${option.user
        .middleName || ""}`;
    }

    if (this.type === "document_managers") {
      label = `${option.user.lastName} ${option.user.firstName} ${option.user
        .middleName || ""}`;
    }

    if (this.type === "content_managers") {
      label = `${option.user.lastName} ${option.user.firstName} ${option.user
        .middleName || ""}`;
    }

    if (this.type === "learning_request_manager") {
      label = `${option.user.lastName} ${option.user.firstName} ${option.user
        .middleName || ""}`;
    }

    if (this.type === "categories") {
      label = `${option.title}`;
    }

    if (this.type === "courses") {
      label = `${option.title}`;
    }

    if (this.type === "webinars") {
      label = `${option.title}`;
    }

    if (this.type === "videos") {
      label = `${option.title}`;
    }

    if (this.type === "education_protocol") {
      label = `${option.number}`;
    }
    return label;
  }

  getEmail(item: any) {
    let email: string = "";

    if (
      this.type === "users" ||
      this.type === "document_managers" ||
      this.type === "content_managers" ||
      this.type === "learning_request_manager" ||
      this.type === "course_listener" ||
      this.type === "webinar_listener" ||
      this.type === "video_listener"
    ) {
      if (item.email) {
        email = item.email;
      } else if (item.user.email) {
        email = item.user.email;
      }
    }
    return email;
  }

  get debouncedGetEntity() {
    return debounce(this.searchEntity, 500);
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get documentManager() {
    return this.$store.getters.roles.includes("document_manager");
  }

  get learningRequestManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }

  get userId() {
    return getCurrentUserId();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get isOwner() {
    return currentUserIsCompanyOwner();
  }

  clearEntity() {
    this.entity = undefined;
  }

  getVideos(searchString: string | undefined = undefined) {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;

    if (
      this.root ||
      this.companyOwner ||
      this.documentManager ||
      this.learningRequestManager
    ) {
      let params: VideoListParams = {
        title: searchString,
        companyId: this.companyId
      };

      video(params)
        .then((res: { data: IVideoList }) => {
          if (res.data.videos.length) {
            this.entityList = res.data.videos;
            if (this.showFirstOption) this.entity = res.data.videos[0];
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    } else {
      let params: VideoListParams = {
        title: searchString,
        companyId: this.companyId,
        ownerId: this.userId
      };
      video(params)
        .then((res: { data: IVideoList }) => {
          if (res.data.videos.length) {
            this.entityList = res.data.videos;
            if (this.showFirstOption) this.entity = res.data.videos[0];
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getWebinars(searchString: string | undefined = undefined) {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;

    if (
      this.root ||
      this.companyOwner ||
      this.documentManager ||
      this.learningRequestManager
    ) {
      let params: WebinarsListParams = {
        title: searchString,
        companyId: this.companyId
      };

      webinars({ ...params, ...this.searchParams })
        .then((res: { data: IWebinarList }) => {
          if (res.data.webinars.length) {
            this.entityList = res.data.webinars;
            if (this.showFirstOption) this.entity = res.data.webinars[0];
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    } else {
      let params: WebinarsListParams = {
        title: searchString,
        companyId: this.companyId,
        ownerId: this.userId
      };
      webinars({ ...params, ...this.searchParams })
        .then((res: { data: IWebinarList }) => {
          if (res.data.webinars.length) {
            this.entityList = res.data.webinars;
            if (this.showFirstOption) this.entity = res.data.webinars[0];
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getCourses(searchString: string | undefined = undefined) {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;

    if (
      this.root ||
      this.companyOwner ||
      this.documentManager ||
      this.learningRequestManager
    ) {
      let params: CourseListParams = {
        title: searchString,
        companyIds: [this.companyId],
        order: "DESC",
        sort: "updatedAt",
        mode: "v2"
      };

      course(params)
        .then((res: { data: CourseUnionList }) => {
          if (res.data.courses.length) {
            this.entityList = res.data.courses;
            if (this.showFirstOption) this.entity = res.data.courses[0];
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    } else {
      let params: CourseListParams = {
        title: searchString,
        companyIds: [this.companyId],
        ownerIds: [this.userId],
        order: "DESC",
        sort: "updatedAt",
        mode: "v2"
      };
      course(params)
        .then((res: { data: CourseUnionList }) => {
          if (res.data.courses.length) {
            this.entityList = res.data.courses;
            if (this.showFirstOption) this.entity = res.data.courses[0];
          }
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getLearningRequestManager() {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;

    let params: EmployeeListParams = {
      id: this.companyId,
      limit: 100,
      roles: ["learning_request_manager"]
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.showSpinner = false;
      this.entityList = res.data.employees;
      if (this.entityList.length > 0) {
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getDocumentManagers() {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;

    let params: EmployeeListParams = {
      id: this.companyId,
      limit: 100,
      roles: ["document_manager"]
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.showSpinner = false;
      this.entityList = res.data.employees;
      if (this.entityList.length > 0) {
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getContentManagers() {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;

    let params: EmployeeListParams = {
      id: this.companyId,
      limit: 100,
      roles: ["content_manager"]
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.showSpinner = false;
      this.entityList = res.data.employees;
      if (this.entityList.length > 0) {
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getEducationProtocols(searchString: string | undefined = undefined) {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;
    let params: EducationProtocolListParams = {
      companyId: this.companyId,
      ownerId: this.root || this.isOwner ? undefined : this.currentEmployee.id,
      limit: 999,
      number: searchString
    };
    educationProtocol(params).then(
      (res: { data: IEducationProtocolShortList }) => {
        this.entityList = res.data.items;
        if (this.entityList.length) {
          if (this.showFirstOption) this.entity = this.entityList[0];
        }
        this.showSpinner = false;
      }
    );
  }

  getLectures(searchString: string | undefined = undefined) {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;
    let params: LectureListParams = {
      companyId: this.companyId,
      title: searchString
    };
    lectures(params).then((res: { data: ILecturesList }) => {
      this.entityList = res.data.lectures;
      this.showSpinner = false;
    });
  }

  getCategories() {
    this.entityList = [];
    this.entity = undefined;
    this.showSpinner = true;
    let params: CategoriesListParams = {
      companyId: this.companyId,
      limit: 600
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.entityList = res.data.items;
        if (this.entityList.length) {
          if (this.showFirstOption) this.entity = this.entityList[0];
        }
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getContractors(searchString: string | undefined = undefined) {
    this.showSpinner = true;
    this.entityList = [];
    let allSearchParams = [];
    let titleParam: ContractorsListParams = {
      title: searchString
    };
    let shortTitleParam: ContractorsListParams = {
      shortTitle: searchString
    };
    let innParams: ContractorsListParams = {
      inn: searchString
    };
    allSearchParams.push(titleParam, shortTitleParam, innParams);
    allSearchParams.forEach(element => {
      contractors(element).then((res: { data: any }) => {
        if (res.data?.items?.length > 0) {
          res.data.items.forEach((item: any) => {
            this.entityList?.push(item);
          });
          this.entityList = uniqBy(this.entityList, "id");
          if (this.entityList.length) {
            if (this.showFirstOption) this.entity = this.entityList[0];
          }
        }
        this.showSpinner = false;
      });
    });
  }

  getUsers(searchString: string | undefined = undefined) {
    this.showSpinner = true;
    this.entityList = [];
    let allParams = [];
    let firstNameParam: UsersListParams = {
      firstName: searchString
    };
    let lastNameParam: UsersListParams = {
      lastName: searchString
    };
    let emailParam: UsersListParams = {
      email: searchString
    };
    allParams.push(firstNameParam, lastNameParam, emailParam);
    allParams.forEach(element => {
      userList(element).then((res: { data: IUsersList }) => {
        this.showSpinner = false;
        if (res.data.users && res.data.users.length > 0) {
          this.entityList = [];
          res.data.users.forEach(item => {
            this.entityList?.push(item);
          });
          this.entityList = uniqBy(this.entityList, "id");
          if (this.entityList.length) {
            if (this.showFirstOption) this.entity = this.entityList[0];
          }
        }
      });
    });
  }

  //Подстановка юзера по входным параметрам
  getUsersByIdInProp() {
    api.UsersApi.get(this.propEntity).then((res: { data: IUser }) => {
      if (res.data) {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getEducationProtocolByIdInProp() {
    api.EducationProtocolApi.get(this.propEntity.id).then(
      (res: { data: IEducationProtocol }) => {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    );
  }

  getContractorsByIdInProp() {
    api.ContractorApi.get(this.propEntity).then(
      (res: { data: IContractor }) => {
        if (res.data) {
          this.entityList = [];
          this.entityList.push(res.data);
          if (this.showFirstOption) this.entity = this.entityList[0];
        }
      }
    );
  }

  getCoursesByParams() {
    this.showSpinner = true;
    api.CourseApi.get(this.propEntity)
      .then((res: { data: ICourse }) => {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getWebinarsByParams() {
    this.showSpinner = true;
    api.WebinarApi.get(this.propEntity)
      .then((res: { data: IWebinar }) => {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getVideosByParams() {
    this.showSpinner = true;
    api.VideoApi.get(this.propEntity)
      .then((res: { data: IVideo }) => {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getCategoriesByParams() {
    categoryApi.category.getCategory(this.propEntity)
      .then((res: { data: ICategory }) => {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getDocumentManagersByParams() {
    api.EmployeeApi.get(
      this.propEntity.companyId,
      this.propEntity.responsibleId
    ).then((res: { data: IEmployee }) => {
      if (res.data) {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getLearningRequestManagerByParams() {
    api.EmployeeApi.get(
      this.propEntity.companyId,
      this.propEntity.responsibleId
    ).then((res: { data: IEmployee }) => {
      if (res.data) {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getCourseListenerByCourseId() {
    let params: CourseListenersListParams = {
      id: this.propEntity,
      offset: 0,
      limit: 1000
    };

    courseListeners(params).then((res: { data: ICourseListenersList }) => {
      if (res.data) {
        this.entityList = [];
        this.entityList = res.data.listeners;
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  getWebinarListenerByWebinarId() {
    api.WebinarApi.getViewers(this.propEntity, 0, 1000).then(
      (res: { data: IUsersList }) => {
        if (res.data.users) {
          this.entityList = [];
          this.entityList = res.data.users;
          if (this.showFirstOption) this.entity = this.entityList[0];
        }
      }
    );
  }

  getVideoListenerByVideoId() {
    api.VideoApi.getViewers(this.propEntity, 0, 1000).then(
      (res: { data: IUsersList }) => {
        if (res.data.users) {
          this.entityList = [];
          this.entityList = res.data.users;
          if (this.showFirstOption) this.entity = this.entityList[0];
        }
      }
    );
  }

  getContentManagerByParams() {
    api.EmployeeApi.get(
      this.propEntity.companyId,
      this.propEntity.responsibleId
    ).then((res: { data: IEmployee }) => {
      if (res.data) {
        this.entityList = [];
        this.entityList.push(res.data);
        if (this.showFirstOption) this.entity = this.entityList[0];
      }
    });
  }

  @Watch("entity")
  update() {
    this.$emit("select", this.entity);
    this.$emit("input", this.entity);
  }

  @Watch("companyId")
  updateView() {
    this.checkType();
  }

  @Watch("type")
  updateByType() {
    this.entityList = undefined;
    this.entity = undefined;
    if (this.type) {
      this.checkType();
    }
  }

  @Watch("propEntity")
  updateByProp() {
    this.checkType();
  }

  // Проверка типов для первичного построения шаблона
  checkType() {
    if (this.propEntity) {
      if (this.type === "users") {
        this.getUsersByIdInProp();
      }
      if (this.type === "contractors") {
        this.getContractorsByIdInProp();
      }
      if (this.type === "document_managers") {
        this.getDocumentManagersByParams();
      }
      if (this.type === "learning_request_manager") {
        this.getLearningRequestManagerByParams();
      }
      if (this.type === "content_managers") {
        this.getContentManagerByParams();
      }
      if (this.type === "categories") {
        this.getCategoriesByParams();
      }
      if (this.type === "courses") {
        this.getCoursesByParams();
      }
      if (this.type === "webinars") {
        this.getWebinarsByParams();
      }
      if (this.type === "videos") {
        this.getVideosByParams();
      }
      if (this.type === "course_listener") {
        this.getCourseListenerByCourseId();
      }
      if (this.type === "webinar_listener") {
        this.getWebinarListenerByWebinarId();
      }
      if (this.type === "video_listener") {
        this.getVideoListenerByVideoId();
      }
      if (this.type === "education_protocol") {
        this.getEducationProtocolByIdInProp();
      }
    } else {
      if (this.type === "users") {
        this.getUsers();
      }
      if (this.type === "contractors") {
        this.getContractors();
      }
      if (this.type === "document_managers" && this.companyId) {
        this.getDocumentManagers();
      }
      if (this.type === "lectures" && this.companyId) {
        this.getLectures();
      }
      if (this.type === "learning_request_manager" && this.companyId) {
        this.getLearningRequestManager();
      }
      if (this.type === "content_managers" && this.companyId) {
        this.getContentManagers();
      }
      if (this.type === "categories") {
        this.getCategories();
      }
      if (this.type === "courses") {
        this.getCourses();
      }
      if (this.type === "webinars") {
        this.getWebinars();
      }
      if (this.type === "videos") {
        this.getVideos();
      }
      if (this.type === "education_protocol") {
        this.getEducationProtocols();
      }
    }
  }

  mounted() {
    this.checkType();
  }
}
